import { cn, createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import tools from "@/utils/tool";
import "./index.scss";

export type IconName =
  | "unknown"
  | "username"
  | "phone"
  | "pwd"
  | "code"
  | "otp"
  | "checked"
  | "unchecked"
  | "sell-white"
  | "buy-white"
  | "exchange-white"
  | "help-orange"
  | "customer-red"
  | "scan-green"
  | "balance-blue"
  | "Vbi"
  | "copy"
  | "verify"
  | "unverify"
  | "notice"
  | "non-notice"
  | "operate_arrow_right"
  | "global_notice"
  | "root-home"
  | "root-trade"
  | "root-orders"
  | "root-user"
  | "customer-service"
  | "messages"
  | "sort"
  | "sort-active"
  | "filter"
  | "vcoin"
  | "bank"
  | "alipay"
  | "wechat"
  | "user-verify"
  | "user-aboutus"
  | "user-advice"
  | "user-devices"
  | "user-name"
  | "user-note"
  | "user-save"
  | "user-arrow-right"
  | "user-copy"
  | "user-customer"
  | "user-edit"
  | "user-level"
  | "user-wallet"
  | "user-exchange"
  | "notice-fill"
  | "notice-empty"
  | "notice-icon"
  | "order-desc"
  | "order-asc"
  | "header-back"
  | "clean"
  | "trash"
  | "psw-show"
  | "psw-hide"
  | "camera"
  | "scan"
  | "key"
  | "delete"
  | "approval"
  | "approval-active"
  | "id-card"
  | "id-card-active"
  | "scan-face"
  | "scan-face-active"
  | "header-kefu"
  | "step-success"
  | "exchange"
  | "platform-sure"
  | "margin_balance"
  | "profit"
  | "seller_balance"
  | "USDT"
  | "digital_rmb"
  | "circle-uploader";

export interface IconProps extends ComponentBase.Component {
  name: IconName;
  size?: NormalSize | ArrarySize;
}
type NormalSize = number | string;
type ArrarySize = (string | number)[];
export const Icon = ({ name, size, className }: IconProps) => {
  const b = createBEM("i-icon");

  const checkUnit = (v: number | string | undefined): string => {
    if (v === undefined || v === "") return "";
    if (tools.isNumber(v)) return `${v}px`;
    if (tools.isString(v)) {
      if ((v as string).endsWith("px")) return v as string;
      if ((v as string).endsWith("rem")) return v as string;
      return `${v}px`;
    }
    return `${v}px`;
  };

  return (
    <span
      className={cn(b(), name, className)}
      style={{
        width:
          size && Array.isArray(size as ArrarySize)
            ? checkUnit((size as ArrarySize)[0])
            : checkUnit(size as NormalSize),
        height:
          size && Array.isArray(size as ArrarySize)
            ? checkUnit((size as ArrarySize)[1])
            : checkUnit(size as NormalSize),
      }}
    ></span>
  );
};
